"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureFlagEnabled = void 0;
const react_1 = require("react");
const usePostHog_1 = require("./usePostHog");
function useFeatureFlagEnabled(flag) {
    const client = (0, usePostHog_1.usePostHog)();
    const [featureEnabled, setFeatureEnabled] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!client) {
            return;
        }
        return client.onFeatureFlags(() => {
            setFeatureEnabled(client.isFeatureEnabled(flag));
        });
    }, [client, flag]);
    return featureEnabled;
}
exports.useFeatureFlagEnabled = useFeatureFlagEnabled;
